import {createApp} from 'vue'
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./assets/custom.css";
import App from './App.vue'
import router from "@/router";
import store from "@/store";
import http from "@/http";
import YmapPlugin from 'vue-yandex-maps'
import money from 'v-money'
import moment from "moment";
import "moment/src/locale/uz"
import {QuillEditor} from "@vueup/vue-quill";
import '@vueup/vue-quill/dist/vue-quill.snow.css';


moment.locale('uz');
import CKEditor from '@ckeditor/ckeditor5-vue';

const settings = {
    apiKey: '',
    lang: 'ru_RU',
    coordorder: 'latlong',
    enterprise: false,
    version: '2.1'
}

const app = createApp(App);
app.config.globalProperties.$http = http;
app.config.globalProperties.$moment = moment;

app.component('QuillEditor', QuillEditor);
app.use(ElementPlus);
app.use(CKEditor);
app.use(router);
app.use(store);
app.use(YmapPlugin, settings);
app.use(money, {precision: 2});


app.mount('#app')
